export const NorthPackages = [
  {
    tour: "Kasol",
    price: "5,500",
    review: "12",
    offer: false,
    location: "https://goo.gl/maps/wwHoe11t8DjSfV9v5",
    pdf:
      process.env.PUBLIC_URL + "/travel-pdf/North/Himachal/Kasol_FVN_H_01.pdf",
    image: [
      process.env.PUBLIC_URL + "/images/North/kasol/3.jpg",
      process.env.PUBLIC_URL + "/images/North/kasol/1.jpg",
      process.env.PUBLIC_URL + "/images/North/kasol/2.jpg",
    ],
    description: `This tiny little village, Kasol, on the banks of the Parvati river in Parvati Valley seems to speak with the hippie souls like no other place in Himachal Pradesh does. Yes, it has gained popularity in recent decades along with other villages of Parvati Valley, and the OGs would tell you that the charm is fading. But, there is still magic left when sitting beside the Parvati river and hear her sing those exclusive musical tunes!`,
    miniDescription: `This tiny little village, Kasol, on the banks of the Parvati river in Parvati Valley seems to speak with the hippie souls like no other place in Himachal Pradesh does`,
    hightlights: `<ul>
        <li>Arrive at pickup point (Majnu ka
          Tila/Kashmiri Gate). From Delhi, transfer
          to Manali in A/C Bus.
          </li>
        <li> Arrive at Manali in Morning –
        Check into the Hotel. Later Visit
        Hadimba Devi Temple, Manu
        Temple, and Vashist Hot Water
        Spring.
        </li>
        <li>After a hearty breakfast, proceed for an adventurous
        trip to Solang (snow point), Atal tunnel,Sisu return back
        to hotel.
        </li>
        <li>After a hearty breakfast, Check out from Hotel and
        proceed for an adventurous trip to Kullu.
        Later we'll proceed towards Kasol. Check into your
        Camps. Soak in the peace & beauty of Parvati Valley.
        </li>
        <li>After a hearty breakfast, check out by
        11:00 am and put on your trekking
        shoes! As today we'll be exploring
        The Chalal Trek. Trek to this amazing
        Place and capture some mesmerizing
        views of the Mountains like never
        before!
        </li>
        <li>Arrival at Delhi, the
        glarious tour to
        the heavenly Manali
        comes to an end.
        Now its time to say
        goodbye to all with
        lots of memories.
        </li>
        </ul>`,
  },
  {
    tour: "Manali-Kasol",
    price: "5,500",
    review: "22",
    offer: false,
    location: "https://goo.gl/maps/wwHoe11t8DjSfV9v5",
    pdf:
      process.env.PUBLIC_URL +
      "/travel-pdf/North/Himachal/Manali-Kasol_FVN_H_03.pdf",
      image: [
        process.env.PUBLIC_URL + "/images/North/kasol/1.jpg",
        process.env.PUBLIC_URL + "/images/North/kasol/2.jpg",
        process.env.PUBLIC_URL + "/images/North/kasol/3.jpg",
      ],
    description: `One of the most popular hill stations in Himachal, Manali
    offers the most magnificent views covered with snow for
    most parts of the year. With the Covid-19 pandemic
    going on, Manali has evolved to be a place loved by
    young people looking for longer stays for workation.
    With ambient cafes, good wifi availability, small eateries
    and convenient shops, Old Manali is among the favorite
    neighbourhood for such people. There are many
    homestays and hostels offering dorm beds for cheap for
    longer durations.`,
    miniDescription: `One of the most popular hill stations in Himachal, Manali offers the most magnificent views covered with snow for most parts of the year.`,
    hightlights: `<ul>
        <li>Arrive at pickup point (Majnu ka
          Tila/Kashmiri Gate). From Delhi, transfer
          to Manali in A/C Bus.
          </li>
        <li> Arrive at Manali in Morning –
        Check into the Hotel. Later Visit
        Hadimba Devi Temple, Manu
        Temple, and Vashist Hot Water
        Spring.
        </li>
        <li>After a hearty breakfast, proceed for an adventurous
        trip to Solang (snow point), Atal tunnel,Sisu return back
        to hotel.
        </li>
        <li>After a hearty breakfast, Check out from Hotel and
        proceed for an adventurous trip to Kullu.
        Later we'll proceed towards Kasol. Check into your
        Camps. Soak in the peace & beauty of Parvati Valley.
        </li>
        <li>After a hearty breakfast, check out by
        11:00 am and put on your trekking
        shoes! As today we'll be exploring
        The Chalal Trek. Trek to this amazing
        Place and capture some mesmerizing
        views of the Mountains like never
        before!
        </li>
        <li>Arrival at Delhi, the
        glarious tour to
        the heavenly Manali
        comes to an end.
        Now its time to say
        goodbye to all with
        lots of memories.
        </li>
        </ul>`,
  },
  {
    tour: "Manali-Shimla",
    price: "5,500",
    review: "12",
    offer: false,
    location: "https://goo.gl/maps/1aT8XvcjjCtm9BGw5",
    pdf:
      process.env.PUBLIC_URL +
      "/travel-pdf/North/Himachal/Manali-Shimla_FVN_H_04.pdf",
    image: [
      process.env.PUBLIC_URL + "/images/North/manali/1.jpg",
      process.env.PUBLIC_URL + "/images/North/manali/2.jpg",
      process.env.PUBLIC_URL + "/images/North/manali/7.jpg",
      process.env.PUBLIC_URL + "/images/North/manali/3.jpg",
      process.env.PUBLIC_URL + "/images/North/manali/6.jpg",
    ],
    description: `One of the most popular hill stations in Himachal, Manali
    offers the most magnificent views covered with snow for
    most parts of the year. With the Covid-19 pandemic
    going on, Manali has evolved to be a place loved by
    young people looking for longer stays for workation.
    With ambient cafes, good wifi availability, small eateries
    and convenient shops, Old Manali is among the favorite
    neighbourhood for such people. There are many
    homestays and hostels offering dorm beds for cheap for
    longer durations.`,
    miniDescription: `One of the most popular hill stations in Himachal, Manali
    offers the most magnificent views covered with snow for
    most parts of the year.`,
    // hightlights: `<ul>
    //     <li>Short trip to Kufri</li>
    //     <li> A leisure walk at Shimla and Manali Mall Roads</li>
    //     <li>Sightseeing in Manali including Hadmiba Devi Temple and Tibetan Monastery</li>
    //     <li>Excursion to Solang Valley and Rohtang Pass</li>
    //     </ul>`,
  },
  {
    tour: "Spiti Valley",
    price: "5,500",
    review: "12",
    offer: false,
    location: "https://goo.gl/maps/Lx62xNQTamJrhrgn8",
    pdf:
      process.env.PUBLIC_URL +
      "/travel-pdf/North/Himachal/Spiti-Full-Circuit_FVN_H_02.pdf",
    image: [
      process.env.PUBLIC_URL + "/images/North/spiti/1.jpg",
      process.env.PUBLIC_URL + "/images/North/spiti/2.jpg",
      process.env.PUBLIC_URL + "/images/North/spiti/3.jpg",
    ],
    description: `This beautiful location lies between
    Tibet and India; well known for its
    picturesque natural beauty and rich
    cultural heritage. Spiti is widely
    recognised for its glorious murals,
    ancient temples and numerous stupa's.
    This is the exact location for nature
    enthusiasts, adventure seeking
    travellers and photographers.`,
    miniDescription: `This beautiful location lies between
    Tibet and India; well known for its
    picturesque natural beauty and rich
    cultural heritage.`,
    hightlights: `<ul>
        <li>We start our journey from Shimla after
        the breakfast and drive to Narkanda. Depending on the client's choice and
        fitness level we trek or drive all the
        way to Hatu Peak which is
        approximately 6kms from Narkanda. 
        </li>
        <li> We begin the second day by visiting
        famous Bhimakali Temple at
        Sarahan to attend the early
        morning ceremony. The temple is
        made of stones and woods interlocked together in an Indo-
        Tibetan Style.
        </li>
        <li>Starting the third day with a early morning walk at Chitkul village,
        the last habituated village of India. Visit to 500-year-old temple of
        local Diety Maathi in the Chitkul, Kagyupa temple of Sakyamuni
        Buddha and a km walk to Indo-Tibetan Check post will be the
        highlights of the day.
        </li>
        <li>Starting the fourth day at the Kalpa with the
        spectacular view of Mt. Kinner Kailash from Kalpa
        at 6050m will leave you mesmerised. Visit monastery
        and walk amidst the apple orchards of the village
        will be an experience in itself. It's a perfect way to
        experience mountain life with mountain people
        while observing their daily routine in the village.
        </li>
        <li>The secluded village of Nako is a dream
        destination for those who want to
        experience the offbeat frontier traveling. Our 5th day starts with the walk around
        the Nako village which is set on a lake and
        has few charming monasteries surrounded
        by poplar and willow trees.
        </li>
        <li>What could be better than starting your
        day with the none other than "Ajanta of
        the Himalayas"? Yes, you read it right,
        the magnificent preserver of Buddhists
        legacy in Spiti Valley, the Tabo
        monastery, one of the oldest monetary
        in the region.
        </li>
        <li>Starting early on our 7th day of traveling across the
        Trans-Himalayas region, we walk around Kaza, the
        administrative headquarter of Spiti Valley which has a
        market place, hotels, homestay and highest fuel station
        in the world.
        </li>
        <li>Chandra Tal Lake to Manali
        The last day of our travel will start with
        the visit to beautiful moon lake, Chandra
        Tal. For the ones who like to explore
        uncharted territories on foot, there is a
        short trek of 6kms to Chandratal Lake
        from Kunzum Pass.
        </li>
        </ul>`,
  },
  {
    tour: "Kashmir",
    price: "5,500",
    review: "12",
    offer: false,
    location: "https://goo.gl/maps/ouXZXscr3vDhmYHw7",
    pdf:
      process.env.PUBLIC_URL + "/travel-pdf/North/Kashmir/Kashmir_FVN_K_01.pdf",
    image: [
      process.env.PUBLIC_URL + "/images/North/kashmir/1.jpg",
      process.env.PUBLIC_URL + "/images/North/kashmir/2.jpg",
      process.env.PUBLIC_URL + "/images/North/kashmir/3.jpg",
    ],
    description: `Popularly known as the "Paradise on
    Earth", Jammu and Kashmir is world famous for its scenic splendour, snow-capped mountains, plentiful wildlife, exquisite monuments, hospitable people and local handicrafts.
    The unique Kashmiri dress is known as Pheran, the copper kettles are called Samovar, Kangiri is the name of the earthen fire pots wrapped in woven wicker, etc showcase some of this uniqueness.`,
    miniDescription: `Popularly known as the "Paradise on
    Earth", Jammu and Kashmir is world famous for its scenic splendour, snow-capped mountains, plentiful wildlife, exquisite monuments, hospitable people and local handicrafts`,
    hightlights: `<ul>
        <li>The journey starts with arrival in the morning , where you can enjoy your stay in an hotel.After, finding yourself in a comfortable and relaxed zone, we will begin the journey , with beautiful view  of The Dal lake and Aru </li>
        <li> The Day 2 , will again begin with a new energy and a refreshing environment. We will sightsee The Indira Gandhi tulip garden, and move to Pahalgam for its perfect mountain view. </li>
        <li>The Day 3, will sure to provide you with the best ok Kashmir which is Srinagar. A place where memories are captured in the hearts of the traveler.
        </li>
        <li>The Day 4, is specially designed for giving you some thrills and comforts. The last day will begin with The great
        lakes trekking, where you will enjoy the best view of Kashmir and how the  locals live their lives.
        </li>
      </ul>`,
  },
  {
    tour: "Vaishnodevi",
    price: "5,500",
    review: "12",
    offer: false,
    location: "https://goo.gl/maps/73YJqEYP6RTNvZQ19",
    pdf:
      process.env.PUBLIC_URL +
      "/travel-pdf/North/Kashmir/Vaishnodevi_FVN_K_02.pdf",
    image: [
      process.env.PUBLIC_URL + "/images/North/vaishnodevi/1.webp",
      process.env.PUBLIC_URL + "/images/North/vaishnodevi/2.webp",
      process.env.PUBLIC_URL + "/images/North/vaishnodevi/3.jpg",
    ],
    description: `Marvel of the Medieval Times Vaishno Devi is amongs't the most revered Hindu pilgrimage sites in India. Nestled
    in the Trikuta Hills in Jammu, the cave temple of Goddess Vaishno Devi, who is the manifestation of Goddess Parvati or
    Shakti is the said to be the abode of 33 Hindu gods. An all season pilgrimage, Vaishno Devi is thronged by more than 10 millions pilgrims every year. The devotees choose different ways like walking bare feet as well as crawling all the way up to seek Goddess’ blessing and pay gratitude for the wish fulfillment.`,
    miniDescription: `Marvel of the Medieval Times Vaishno Devi is amongst the most revered Hindu pilgrimage sites in India. Nestled in the Trikuta Hills in Jammu, the cave temple of Goddess Vaishno Devi.`,
    // hightlights: `<ul>
    //     <li>Short trip to Kufri</li>
    //     <li> A leisure walk at Shimla and Manali Mall Roads</li>
    //     <li>Sightseeing in Manali including Hadmiba Devi Temple and Tibetan Monastery</li>
    //     <li>Excursion to Solang Valley and Rohtang Pass</li>
    //     </ul>`,
  },
  {
    tour: "Leh-Srinagar",
    price: "5,500",
    review: "12",
    offer: false,
    location: "https://goo.gl/maps/VZPd7D2e77SAp1UF6",
    pdf:
      process.env.PUBLIC_URL +
      "/travel-pdf/North/Leh/Leh-Srimagar_FVN_L_02.pdf",
    image: [
      process.env.PUBLIC_URL + "/images/North/srinagar/3.webp",
      process.env.PUBLIC_URL + "/images/North/srinagar/1.jpeg",
      process.env.PUBLIC_URL + "/images/North/srinagar/2.webp",
    ],
    description: `Leh has been a dream destination to many; from families to friend groups inspired by movies. Famous for the
    high altitude, various passes and the
    rocky terrain the city is a dream
    getaway to cool down. Discover the
    divinity of the monasteries and devour
    the comfort food of the locals.`,
    miniDescription: `Leh has been a dream destination to many; from families to friend groups inspired by movies. Famous for the high altitude, various passes and the rocky terrain the city is a dream getaway to cool down.`,
    // hightlights: `<ul>
    //     <li>Short trip to Kufri</li>
    //     <li> A leisure walk at Shimla and Manali Mall Roads</li>
    //     <li>Sightseeing in Manali including Hadmiba Devi Temple and Tibetan Monastery</li>
    //     <li>Excursion to Solang Valley and Rohtang Pass</li>
    //     </ul>`,
  },
  {
    tour: "Kedarnath",
    price: "5,500",
    review: "12",
    offer: false,
    pdf:
      process.env.PUBLIC_URL +
      "/travel-pdf/North/Uttarakhand/Kedarnath_FVN_UK_01.pdf",
    location: "https://goo.gl/maps/QG3ijF1XZ5AE83UD9",
    image: [
      process.env.PUBLIC_URL + "/images/North/kedarnath/3.jpg",
      process.env.PUBLIC_URL + "/images/North/kedarnath/1.jpg",
      process.env.PUBLIC_URL + "/images/North/kedarnath/2.jpg",
    ],
    description: `Kedarnath Temple is a Hindu temple
    dedicated to the Shiva. The temple is located
    on the Garhwal Himalayan range near the
    Mandakini river, in the state of Uttarakhand,
    India. Due to extreme weather conditions,
    the temple is open to the general public only
    between the months of April and November.
    During the winters, the vigraha from
    Kedarnath temple is carried down to
    Ukhimath where the deity is worshiped for
    the next six months.`,
    miniDescription: `Kedarnath Temple is a Hindu temple
    dedicated to the Shiva. The temple is located
    on the Garhwal Himalayan range near the
    Mandakini river, in the state of Uttarakhand,
    India. `,
    // hightlights: `<ul>
    //     <li>Short trip to Kufri</li>
    //     <li> A leisure walk at Shimla and Manali Mall Roads</li>
    //     <li>Sightseeing in Manali including Hadmiba Devi Temple and Tibetan Monastery</li>
    //     <li>Excursion to Solang Valley and Rohtang Pass</li>
    //     </ul>`,
  },
  {
    tour: "Kedarnath-Tungnath",
    price: "5,500",
    review: "12",
    offer: false,
    pdf:
      process.env.PUBLIC_URL +
      "/travel-pdf/North/Uttarakhand/Kedarnath-Tungnath_FVN_UK_02.pdf",
    location: "https://goo.gl/maps/QG3ijF1XZ5AE83UD9",
    image: [
      process.env.PUBLIC_URL + "/images/North/kedarnath/1.jpg",
      process.env.PUBLIC_URL + "/images/North/kedarnath/2.jpg",
      process.env.PUBLIC_URL + "/images/North/kedarnath/3.jpg",
    ],
    description: `Kedarnath Temple is a Hindu temple
    dedicated to the Shiva. The temple is located
    on the Garhwal Himalayan range near the
    Mandakini river, in the state of Uttarakhand,
    India. Due to extreme weather conditions,
    the temple is open to the general public only
    between the months of April and November.
    During the winters, the vigraha from
    Kedarnath temple is carried down to
    Ukhimath where the deity is worshiped for
    the next six months.`,
    miniDescription: `Kedarnath Temple is a Hindu temple
    dedicated to the Shiva. The temple is located
    on the Garhwal Himalayan range near the
    Mandakini river, in the state of Uttarakhand,
    India.`,
    hightlights: `<ul>
        <li>Haridwar/Rishikesh to Guptkashi, Stay in Hotel </li>
        <li>Trek to Guptkashi to Kedarnath Stay in camps </li>
        <li>Offering prayer to Kedarnath  temple and descends to Gaurikund and stay in Guptkashi.</li>
        <li>At Early morning time Move to chopta (50km travel) and start your trek to Tungnath- Chandrashilla. And back to
        chopta camps, enjoy your snacks at evening time. Overnight stay in luxurious camps in chopta.</li>
        <li>At early morning after breakfast, move to rishikesh (170 km, its takes 5 to 6hour) At evening time enjoy the ganga arti at parmarth niketan. Overnight stay in camps</li>
        <li>At Early morning time Move to chopta (50km travel) and start your trek to Tungnath- Chandrashilla. And back to
        chopta camps, enjoy your snacks at evening time. Overnight stay in luxurious camps in chopta.</li>
        <li>AAt early morning after breakfast, move to marine for rafting and it takes 1 hour. After rafting, move to haridwar. </li>
        </ul>`,
  },
  {
    tour: "Valley Of Flowers",
    price: "5,500",
    review: "12",
    offer: false,
    pdf:
      process.env.PUBLIC_URL +
      "/travel-pdf/North/Uttarakhand/Valley_Of_Flowers_FVN_UK_03.pdf",
    location: "https://goo.gl/maps/RknaSz72Di6Zcqtt6",
    image: [
      process.env.PUBLIC_URL + "/images/North/valley/1.jpg",
      process.env.PUBLIC_URL + "/images/North/valley/2.jpg",
      process.env.PUBLIC_URL + "/images/North/valley/3.jpg",
    ],
    description: `With a stunning backdrop of the mighty
    Himalayan ranges, the Valley of Flowers
    National Park presents an ethereal view and
    an unforgettable experience for visitors.
    Spread over an area of 87 sq km in the
    Chamoli district, the Valley of Flowers
    National Park is a UNESCO World Heritage
    Site and forms one of the two core zones
    (the other being the Nanda Devi National
    Park) of the Nanda Devi Biosphere Reserve.`,
    miniDescription: `With a stunning backdrop of the mighty
    Himalayan ranges, the Valley of Flowers
    National Park presents an ethereal view and
    an unforgettable experience for visitors.`,
    hightlights: `<ul>
        <li>Haridwar to Auli
        Distance: 315 km
        Journey: 10-12 hrs by road
        Along the journey are beautiful sights of
        the emerald rivers. Lunch is arranged on
        the way and we finally reach Govindghat
        by evening. Positioned at the bank of
        River Alaknanada, Govindghat is the
        embarking point of the trek.
        </li>
        <li> Auli to Ghangaria
        Distance: 40 km by road and and 10 km
        by trek
        
        This is what you get to see once
        walking 7 km towards Ghangaria
        village. Trek towards this beautiful
        snow clad mountain and you will
        reach Kag Bhusandi Lake. It’s a
        charming high altitude lake.
        Breakfast early morning and start the
        trek at 7 am towards Ghangaria
        village.
        </li>
        <li>Ghangaria to Valley Of Flowers and back to Ghangaria
        Distance: 13- 14 kms
        Duration: 7-8 hrs by trek
        This day you will witness one of the most alluring places of the world. Its impeccably beautiful
        and pleasing environment will surely entice you.
        Pushpawati river bed is 6 kilometers in the Valley of Flowers.
        So you are entering a dream land.
        </li>Ghangaria to Hemkund Sahib and
        back to Ghangaria
        Distance: 12 km
        Time: 7-8 hrs by trek
        Early breakfast and an early start to
        Sri Hemkund sahib will begin your
        day. Leave by 7am and reach this
        pious Gurudwara. The high altitude
        lake is a treat for nature lovers.
        Excursion to Solang Valley and Rohtang Pass</li>
        <li>Ghangaria to Auli, by evening reach
        Auli
        </li>
        <li>Auli to Haridwar
        Distance: 320 km
        Time: 10-12 hrs by road
        This is last day of the trip. After
        an early departure from Auli,
        you can have breakfast and
        lunch on the way to Haridwar.
        You will reach the destination
        by evening. This is where we
        take leave and the trip
        concludes with great memories.
        </li>
        </ul>`,
  },
  {
    tour: "Varanasi-Ayodhya",
    price: "5,500",
    review: "12",
    offer: false,
    pdf:
      process.env.PUBLIC_URL +
      "/travel-pdf/North/Uttarpradesh/Varanasi-Ayodhya_FVN_UP_01.pdf",
    location: "https://goo.gl/maps/JdV57GLgezTffGEv5",
    image: [
      process.env.PUBLIC_URL + "/images/North/ayodhya/1.jpg",
      process.env.PUBLIC_URL + "/images/North/ayodhya/2.jpg",
      process.env.PUBLIC_URL + "/images/North/ayodhya/3.jpg",
    ],
    description: `Marvel of the Medieval Times.
    Varanasi, also called Benares,
    Banaras, or Kashi, city, southeastern
    Uttar Pradesh state, northern India.
    It is located on the left bank of the
    Ganges (Ganga) River and is one of
    the seven sacred cities of Hinduism.`,
    miniDescription: `Marvel of the Medieval Times.
    Varanasi, also called Benares,
    Banaras, or Kashi, city, southeastern
    Uttar Pradesh state, northern India.`,
    hightlights: `<ul>
        <li>Arrival at Varanasi
        Once you arrive in Varanasi airport
        or railway station, you will meet
        the representative who will pick
        you up to further accompany you to
        the pre-booked hotel where you
        check-in and then proceed on to
        the guided tour to the New Kashi
        Vishwanath Temple (BHU) also
        called Birla Temple, Sankat Mochan
        Temple, and Durga Temple. Get
        back to the hotel and stay
        overnight!
        </li>
        <li> Sightseeing in Varanasi
        Wake up to the early morning
        breakfast and start with the
        sightseeing ventures in one of
        the holiest places on earth that
        is Varanasi. Go out to the Kashi
        Vishwanath Temple,
        Annapurna Devi, Vishalakshi
        Devi, Sankat Mochan Temple.
        </li>
        <li>Varanasi to Ayodhya
        In the wake of the moring breakfast, you will
        transfer to Ayodhya that is another wonderful
        pilgrimage spot where you check-in the prescribed
        hotel and later carry out a travel to the banks of the
        Gogra river.
        </li>
        <li>Ayodhya - Prayagraj
        In the wake of the morning breakfast,
        you will get transferred to Prayagrah
        where you will pay a visit to the
        Triveni Sangam, Prayag
        Madhveshwari, Bade Hanuman temple
        and also Anand Bhawan Museum.
        </li>
        </ul>`,
  },
  {
    tour: "Manali",
    price: "13,000",
    review: "24",
    location: "https://goo.gl/maps/QG3ijF1XZ5AE83UD9",
    offer: true,
    // pdf:process.env.PUBLIC_URL + "/travel-pdf/North/Uttarpradesh/Varanasi-Ayodhya_FVN_UP_01.pdf",
    image: [
      process.env.PUBLIC_URL + "/images/North/manali/1.jpg",
      process.env.PUBLIC_URL + "/images/North/manali/2.jpg",
      process.env.PUBLIC_URL + "/images/North/manali/7.jpg",
      process.env.PUBLIC_URL + "/images/North/manali/3.jpg",
      process.env.PUBLIC_URL + "/images/North/manali/6.jpg",
    ],
    description: `Looking for a trip to Himachal? We offer a tastefully crafted Shimla Manali tour that covers all the important attractions and activities. Himachal Pradesh is dotted with a number of scenic hill stations, which are extremely popular as summer holiday destinations. Shimla and Manali are two such places, which do not only have natural beauty in abundance but also have a number of tourist attractions.
        Opt for a Magnificent Shimla Manali tour with a well-planned itinerary by Indian Holiday, offering the best of these places. The 5 nights and 6 days Shimla Manali trip lets you explore Kufri, Solang Valley, Rohtang Pass, and other famous tourist attractions in Himachal Pradesh.
        So what are you waiting for? Get ready to treat your eyes to the picturesque beauty spread all around. Contact us today and get great deals on the Shimla Manali tour package price.`,
    miniDescription: `Looking for a trip to Himachal? We offer a tastefully crafted Shimla Manali tour that covers all the important attractions and activities.`,
    hightlights: `<ul>
        <li>Short trip to Kufri</li>
        <li> A leisure walk at Shimla and Manali Mall Roads</li>
        <li>Sightseeing in Manali including Hadmiba Devi Temple and Tibetan Monastery</li>
        <li>Excursion to Solang Valley and Rohtang Pass</li>
        </ul>`,
  },
  {
    tour: "Auli Tour",
    price: "12,500",
    review: "16",
    offer: false,
    location: "https://goo.gl/maps/ue3Xk2FbhCSLpWCBA",
    image: [
      process.env.PUBLIC_URL + "/images/North/auli/1.jpg",
      process.env.PUBLIC_URL + "/images/North/auli/5.jpg",
      process.env.PUBLIC_URL + "/images/North/auli/3.jpg",
      process.env.PUBLIC_URL + "/images/North/auli/4.jpeg",
    ],
    description: `Auli Tour Package from Delhi spans for 6 days/ 5 nights offering you a wonderful chance to visit some of the scenic and highly revered places in India. The destinations that are covered during this well-planned itinerary are Haridwar, Auli, Rishikesh, and Joshimath. All these destinations are blessed with eye-catching natural beauty and renowned attractions alluring a lot of devotees and travelers every year.
    Haridwar is a spiritual delight, where you will partake in the sacred Ganga Aarti at Har ki Paudi ghat. En route Joshimath, you will be treated to sacred sites of Devprayag, Rudraprayag, and Karnprayag. A scenic cable car ride and skiing in Auli add to your vacation delight. Attractions like Gurso Bugyal, Trishul Peak, and Auli artificial lake will enhance your holiday charm.
    Rishikesh will manifold your touristy spree. It is essentially visited for its ancient temples and ashrams. Visit Narsingh Temple and Shankaracharya Math. Other than this, you may also opt for trekking, rafting, mountaineering, rock climbing, and other amazing activities in Rishikesh. This 6 day Auli Tour from Delhi also provides you with smooth transfers, delish meals, and cozy stays apart from wonderful sightseeing. So, book your package today for a trip to treasure.
    `,
    miniDescription: `Auli Tour Package from Delhi spans for 6 days/ 5 nights offering you a wonderful chance to visit some of the scenic and highly revered places in India.`,
    hightlights: `<ul>
    <li>Guided tour of Auli</li>
    <li> Enjoy Skiing in Auli</li>
    <li>Evening Ganga arti at Har-ki-Paudi in Haridwar</li>
    <li>Visit to Parmarth Niketan Ashram, Maharishi Mahesh Yogi's Ashram, Sivananda Ashram in Rishikesh</li>
    <li>Visit Ram Jhula  & Laxman Jhula in Rishikesh</li>
    <li>Enjoy the magnificent views of Nanda Devi peak and Artificial Lake, Auli</li>
    <li>Visit to Devprayag, Rudraprayag and Karnaprayag</li>
    </ul>`,
  },
  {
    tour: "Ladakh Tour",
    price: "18,500",
    review: "16",
    offer: false,
    location: "https://goo.gl/maps/UhH6H69xKLdGnMX59",
    pdf: process.env.PUBLIC_URL + "/travel-pdf/North/Leh/Leh-Leh_FVN_L_01.pdf",
    image: [
      process.env.PUBLIC_URL + "/images/North/ladakh/1.jpg",
      process.env.PUBLIC_URL + "/images/North/ladakh/2.jpg",
      process.env.PUBLIC_URL + "/images/North/ladakh/3.jpg",
      process.env.PUBLIC_URL + "/images/North/ladakh/4.jpg",
    ],
    description: `Panoramic Ladakh Tour, a package of 10 nights and 11 days offers you a chance to visit the well-known destinations of Ladakh. During the itinerary, you explore places such as Keylong, Sarchu, Leh, Nubra, Lamayuru, and Kargil. The itinerary takes you to the well-known tourist spots, some very famous ancient monasteries, and some extremely beautiful regions of Ladakh. Visits to Nubra valley and Pangong Lake are two of the highlights of this itinerary.`,
    miniDescription: `Panoramic Ladakh Tour, a package of 10 nights and 11 days offers you a chance to visit the well-known destinations of Ladakh.`,
    hightlights: `<ul>
    <li>Drive past Rohtang Pass, en-route Keylong</li>
    <li> Admire the picturesque location of Sarchu valley</li>
    <li>Guided tours to Shanti Stupa and Leh Palace in Leh</li>
    <li>Visit Diskit Monastery- the oldest and the largest Buddhist Gompa of Nubra</li>
    <li>Excursions to Phyang and Spituk Monasteries in Leh</li>
    <li>Indulge in shopping at the local market of Leh</li>
    <li>Halt at the ruins of the 15th century Basgo Castle, en-route Lamayuru</li>
    <li>Visit the monolithic rock-cut statue of Maitreya Buddha in Mulbekh, en-route Kargil</li>
    <li>Halt at  Drass- known as the second coldest place on earth, on the way to Srinagar</li>
    </ul>`,
  },
  {
    tour: "Jaipur",
    price: "11,500",
    review: "16",
    offer: false,
    image: [
      process.env.PUBLIC_URL + "/images/North/jaipur/2.jpg",
      process.env.PUBLIC_URL + "/images/North/jaipur/3.jpg",
      process.env.PUBLIC_URL + "/images/North/jaipur/1.jpg",
    ],
    description: `Also known as the ‘Pink City, Jaipur accounts for memorable holidays in Rajasthan. The Jaipur tour package lets you explore the stunning attractions of the city. The 2 nights/ 3 days Jaipur tour package provides exciting opportunities to marvel at spellbinding sites like Hawa Mahal, City Palace, Jantar Mantar, etc. The tastefully-crafted itinerary helps you embark on the exciting trip to the Amber Fort. The wonderful sojourn is sure to bestow you with memories of a lifetime.`,
    miniDescription: `Also known as the ‘Pink City, Jaipur accounts for memorable holidays in Rajasthan. The Jaipur tour package lets you explore the stunning attractions of the city.`,
    hightlights: `<ul>
    <li>Guided tour of Jaipur</li>
    <li>Visit City Palace, Hawa Mahal, Jantar Mantar in Jaipur</li>
    <li>Sightseeing tour of Amber Fort</li>
    <li>Enjoy an elephant ride at Amber Fort</li>
    </ul>`,
  },

  {
    tour: "Nanital",
    price: "14,000",
    review: "34",
    offer: true,
    location: "https://goo.gl/maps/hDkrB5Hhwh6KLxkbA",
    image: [
      process.env.PUBLIC_URL + "/images/North/nanital/1.jpeg",
      process.env.PUBLIC_URL + "/images/North/nanital/2.jpg",
      process.env.PUBLIC_URL + "/images/North/nanital/3.jpg",
    ],
    description: `Nainital is a famous hill station in Uttarakhand. It is popular for its captivating landscapes, emerald lakes, and ancient temples. With our 5 Nights/ 6 Days Jim Corbett with Nainital tour, you can explore the tourist places of this beautiful hill town such as Naini Lake, Snow View Point, Tiffin Top, Naukuchiatal, and Naini Peak. You can also enjoy the jungle safari in Jim Corbett National Park and spot some exquisite wildlife species in their natural habitat. It is a perfect place to travel with family or for a honeymoon. Our well-customized itinerary includes comfortable stays, meals, transportations, and city tours that promise an exciting holiday.`,
    miniDescription: `Nainital is a famous hill station in Uttarakhand. It is popular for its captivating landscapes, emerald lakes, and ancient temples.`,
    hightlights: `<ul>
    <li>Enjoy Jeep Safari and elephant ride at Jim Corbett National Park</li>
    <li>Sightseeing at Naina Peak, Naina Devi Temple, Snow View, Tiffin Top </li>
    <li>Visit scenic lake at Bhimtal, Sattal, and Naukuchiatal</li>
    <li>Enjoy Boat ride & Ropeway ride at Nainital</li>
    <li>Sightseeing at the beautiful Mukteshwar</li>
    <li> Explore exotic wildlife at Jim Corbett National park</li>
    </ul>`,
  },
];

export const SouthPackages = [
  {
    tour: "Andaman",
    price: "16,500",
    review: "10",
    offer: false,
    location: "https://goo.gl/maps/q8Knb5WoP6mP68vY7",
    pdf:
      process.env.PUBLIC_URL + "/travel-pdf/South/Andaman/Andaman_FVS_A_01.pdf",
    image: [
      process.env.PUBLIC_URL + "/images/South/andaman/1.webp",
      process.env.PUBLIC_URL + "/images/South/andaman/2.jpeg",
      process.env.PUBLIC_URL + "/images/South/andaman/3.avif",
    ],
    description: `TheAndamanArchipelagoisanoceanic
    continuationof theBurmeseArakan
    Yomarange intheNorthandof the
    IndonesianArchipelagointhe South.It
    has 325 islandswhichcoveranareaof
    6,408km2 (2,474 sqmi),withtheAndaman
    Seatothe eastbetweenthe islandsand
    
    the coastofBurma.`,
    miniDescription: `TheAndamanArchipelagoisanoceanic
    continuationof theBurmeseArakan
    Yomarange intheNorthandof the
    IndonesianArchipelagointhe South.`,
    // hightlights: `<ul>
    // <li>Visit Kesava temple at Somnathpur</li>
    // <li>Guided tour to the major attractions of Mysore covering the Golden Royal Elephant, the Mysore Palace, Chamundeshwari temple, Brindavan Gardens, Mysore Zoo, and the Durbar hall.</li>
    // <li>Visit Shravanbelagola, noted for its 17-meter high statue of Lord Gomateshvara</li>
    // <li>Excursion to Horanadu and Baha Budan Giri the major tourist attractions of Chikmagalur.</li>
    // <li>Full day tour to Badami Fort, Open Air Museum, and the Cave temples</li>
    // <li>Guided tour to the Chapel of St Francis Xavier, the Church of St Francis of Assisi, and the Basilica of Bom Jesus,
    // Boat cruise on Mandovi River</li>
    // <li>Visit Badami cave temples, at Badami</li>
    // <li>Day trip to major tourist attractions of South Goa include Santa Durga Temple, Mangeshi Temple, Colva Beach</li>
    // </ul>`,
  },
  {
    tour: "Tamil Nadu",
    price: "11,500",
    review: "15",
    offer: true,
    location: "https://goo.gl/maps/CehDnk5LomcMvZek6",
    pdf:
      process.env.PUBLIC_URL +
      "/travel-pdf/South/TamilNadu/TamilNadu_FVS_TN_01.pdf",
    image: [
      process.env.PUBLIC_URL + "/images/South/tamilnadu/1.webp",
      process.env.PUBLIC_URL + "/images/South/tamilnadu/2.jpeg",
      process.env.PUBLIC_URL + "/images/South/tamilnadu/3.webp",
    ],
    description: `Hinduism lies at the core of the culture
    of Tamil Nadu. Among the most famous
    of the state’s temples, which number in
    the tens of thousands, are the 7th- and
    8th-century structures at
    Mamallapura, which were designated a
    UNESCO World Heritage Site in 1984.
    The gopurams, or gateway towers, of
    such temples are dominant in most
    towns, particularly Chidambaram,
    Kanchipuram, Thanjavur, Madurai, and
    the Srirangam pilgrimage centre in
    Tiruchchirappalli.`,
    miniDescription: `Hinduism lies at the core of the culture
    of Tamil Nadu. Among the most famous
    of the state’s temples, which number in
    the tens of thousands, are the 7th- and
    8th-century structures at
    Mamallapura.`,
    // hightlights: `<ul>
    // <li>Stay in a treehouse in Munnar</li>
    // <li> Sightseeing in Munnar including Eravikulam National Park.</li>
    // <li>Houseboat cruise in and around Alleppey.</li>
    // <li>City tour in Kovalam</li>
    // <li>Morning sightseeing in Trivandrum</li>
    // </ul>`,
  },
  {
    tour: "Yelagiri",
    price: "11,000",
    review: "14",
    offer: true,
    location: "https://goo.gl/maps/3JmDSS1wpcN53V5r5",
    pdf:
      process.env.PUBLIC_URL +
      "/travel-pdf/South/TamilNadu/Yelagiri_FVS_T_01.pdf",
    image: [
      process.env.PUBLIC_URL + "/images/South/yelagiri/1.webp",
      process.env.PUBLIC_URL + "/images/South/yelagiri/2.webp",
      process.env.PUBLIC_URL + "/images/South/yelagiri/3.jpeg",
    ],
    description: `The Hill station of Tamil Nadu. Beat the heat of Tamil Nadu and discover the
    valleys, waterfalls and colourful sights of
    Yelagiri. Find all the fun and adventure on this
    trip, but we promise you won't miss out on the
    rich culture either. Experience the earthy,
    spicy, tangy flavours in the Tamil cuisine
    yourself and indulge in the authentic desserts.
    A surpise awaits you on the last day of your
    journey!`,
    miniDescription: `The Hill station of Tamil Nadu. Beat the heat of Tamil Nadu and discover the
    valleys, waterfalls and colourful sights of
    Yelagiri. Find all the fun and adventure on this
    trip.`,
    // hightlights: `<ul>
    // <li>Explore Tipu Sultan's Palace and Ranganathaswamy Temple, Bangalore</li>
    // <li> Darshan at Chamundi Devi temple, near Mysore.</li>
    // <li>Visit Mysore Palace and Krishnarajasagar Dam, Mysore</li>
    // <li>Short trip to Botanical Garden and Dolphin’s Nose, Ooty</li>
    // </ul>`,
  },
  {
    tour: "Karnataka Tour",
    price: "16,500",
    review: "10",
    offer: false,
    location: "https://goo.gl/maps/Ad4rtUWTa9Y3sv6s5",
    image: [
      process.env.PUBLIC_URL + "/images/South/karnataka/1.jpg",
      process.env.PUBLIC_URL + "/images/South/karnataka/2.jpg",
      process.env.PUBLIC_URL + "/images/South/karnataka/3.jpg",
    ],
    description: `The Karnataka Ancient tour is planned to let you visit some of the ancient monuments of Karnataka. The greatest kingdoms of the South include the Chalukyan Empire. During the reign of the Chalukyan Empire, the country saw the construction of some of the most exquisite temples and forts. Opt for this tour to enjoy the splendid architectural wonders of ancient Karnataka. After viewing these architectural wonders that are centuries old, unwind on the white sunbathed beaches of Goa, making it the perfect end to your holiday.`,
    miniDescription: `The Karnataka Ancient tour is planned to let you visit some of the ancient monuments of Karnataka. The greatest kingdoms of the South include the Chalukyan Empire.`,
    hightlights: `<ul>
    <li>Visit Kesava temple at Somnathpur</li>
    <li>Guided tour to the major attractions of Mysore covering the Golden Royal Elephant, the Mysore Palace, Chamundeshwari temple, Brindavan Gardens, Mysore Zoo, and the Durbar hall.</li>
    <li>Visit Shravanbelagola, noted for its 17-meter high statue of Lord Gomateshvara</li>
    <li>Excursion to Horanadu and Baha Budan Giri the major tourist attractions of Chikmagalur.</li>
    <li>Full day tour to Badami Fort, Open Air Museum, and the Cave temples</li>
    <li>Guided tour to the Chapel of St Francis Xavier, the Church of St Francis of Assisi, and the Basilica of Bom Jesus,
    Boat cruise on Mandovi River</li>
    <li>Visit Badami cave temples, at Badami</li>
    <li>Day trip to major tourist attractions of South Goa include Santa Durga Temple, Mangeshi Temple, Colva Beach</li>
    </ul>`,
  },
  {
    tour: "Kerala",
    price: "11,500",
    review: "15",
    offer: true,
    location: "https://goo.gl/maps/CehDnk5LomcMvZek6",
    image: [
      process.env.PUBLIC_URL + "/images/South/kerala/1.jpg",
      process.env.PUBLIC_URL + "/images/South/kerala/2.jpg",
      process.env.PUBLIC_URL + "/images/South/kerala/4.jpg",
      process.env.PUBLIC_URL + "/images/South/kerala/6.jpg",
    ],
    description: `The South Indian state of Kerala has been blessed with lush scenery, breathtaking vistas, and a wonderful climate, ideal for a couple to create unforgettable memories. Romantic Kerala tour spreads in the duration of 5 nights and 6 days, offering memorable experiences. The well-planned itinerary takes you to popular destinations of Kerala such as Cochin, Munnar, Alleppey, Kovalam and Trivandrum. Some of the highlights of the tour include visit to Eravikulam National Park, stay in a well-equipped tree house, houseboat tour in and around Alleppey and leisure time in Kovalam beach town.`,
    miniDescription: `The South Indian state of Kerala has been blessed with lush scenery, breathtaking vistas, and a wonderful climate, ideal for a couple to create unforgettable memories`,
    hightlights: `<ul>
    <li>Stay in a treehouse in Munnar</li>
    <li> Sightseeing in Munnar including Eravikulam National Park.</li>
    <li>Houseboat cruise in and around Alleppey.</li>
    <li>City tour in Kovalam</li>
    <li>Morning sightseeing in Trivandrum</li>
    </ul>`,
  },
  {
    tour: "Mysore Ooty",
    price: "11,000",
    review: "14",
    offer: true,
    location: "https://goo.gl/maps/kXk7HjRMNaePuoJ48",
    pdf:
      process.env.PUBLIC_URL +
      "/travel-pdf/South/Karnataka/Mysore-ooty_FVS_KA_01.pdf",
    image: [
      process.env.PUBLIC_URL + "/images/South/ooty/1.jpg",
      process.env.PUBLIC_URL + "/images/South/ooty/2.jpg",
      process.env.PUBLIC_URL + "/images/South/ooty/3.jpg",
    ],
    description: `Explore South India's very own golden triangle with our tastefully crafted Mysore Ooty package from Bangalore This 5 days Bangalore Mysore Ooty itinerary gives you the opportunity to explore the rich cultural and historical heritage of Mysore and Bangalore along with a chance to visit the scenic hill station Ooty.
    On the Bangalore, Mysore Ooty tour, explore the lush gardens and lakes of Bangalore, palaces, dams, and gardens in Mysore, and sprawling tea and coffee plantations in Ooty as well as numerous viewpoints and picnic spots.`,
    miniDescription: `Mysore Ooty tour, explore the lush gardens and lakes of Bangalore, palaces, dams, and gardens in Mysore, and sprawling tea and coffee plantations in Ooty`,
    hightlights: `<ul>
    <li>Explore Tipu Sultan's Palace and Ranganathaswamy Temple, Bangalore</li>
    <li> Darshan at Chamundi Devi temple, near Mysore.</li>
    <li>Visit Mysore Palace and Krishnarajasagar Dam, Mysore</li>
    <li>Short trip to Botanical Garden and Dolphin’s Nose, Ooty</li>
    </ul>`,
  },
];

export const EastPackages = [
  {
    tour: "Gangtok-Darjeeling",
    price: "12,000",
    review: "16",
    offer: true,
    location: "https://goo.gl/maps/NtS2cHDaPvrEfF4M7",
    pdf:
      process.env.PUBLIC_URL +
      "/travel-pdf/East/Karnataka/Gangtok-Darjeeling_FVE_AS_01.pdf",
    image: [
      process.env.PUBLIC_URL + "/images/East/gangtok/1.jpeg",
      process.env.PUBLIC_URL + "/images/East/gangtok/2.jpeg",
      process.env.PUBLIC_URL + "/images/East/gangtok/3.jpeg",
    ],
    description: `North East India is indeed a paradise
    unexplored and one of the best destination
    for nature lovers, trekkers and wildlife
    enthusiasts. North East India includes 7
    contiguous states Arunachal Pradesh, Assam,
    Meghalaya, Manipur, Mizoram, Nagaland and
    Tripura, Hence also known as Seven Sister
    States of India. The North Eastern region
    also host one brother called Sikkim and
    some parts of Bengal as Darjeeling,
    Jalpaiguri, and Koch Bihar. It is one of the
    most treasured and Eco-friendly area in
    India with vast natural resources and a
    cauldron of different people and cultures.`,
    miniDescription: `North East India is indeed a paradise
    unexplored and one of the best destination
    for nature lovers, trekkers and wildlife
    enthusiasts. North East India includes 7
    contiguous states of India.`,
    // hightlights: `<ul>
    // <li>In Shillong tour, visit the Elephanta Falls and the Shillong Peak</li>
    // <li> Visit the Seven Sisters Falls in Cherapunjee</li>
    // <li>Visit the famous Kamakhya Temple in Guwahati</li>
    // <li>Visit the Borapani Lake in Shillong tour</li>
    // <li>Visit the Mawsmai Cave and the Thangkharang Park Cherapunji</li>
    // <li>Visit Lady Hydari Park</li>
    // <li>Visit the cleanest village in Asia, Mawlynnong</li>
    // <li>Step foot on the living roots bridge</li>
    // </ul>`,
  },
  {
    tour: "Mawlynnong",
    price: "13,500",
    review: "16",
    offer: false,
    location: "https://goo.gl/maps/Snx2x6eVLQxTPHGQ7",
    pdf:
      process.env.PUBLIC_URL +
      "/travel-pdf/East/Karnataka/Mawlynnong_FVE_M_01.pdf",
    image: [
      process.env.PUBLIC_URL + "/images/East/mawlynnong/1.jpeg",
      process.env.PUBLIC_URL + "/images/East/mawlynnong/2.jpeg",
      process.env.PUBLIC_URL + "/images/East/mawlynnong/3.jpeg",
    ],
    description: `Asia's cleanest village.
    Claimed by Discover India magazine as
    the cleanest village in Asia. Enjoy the
    uninterrupted nature; from loud scenic
    waterfalls to the noble trees that house
    birds and small animals. You may
    choose to observe and capture this or
    make the best of it through adventure
    sports that would help you feel one
    with the nature.`,
    miniDescription: `Asia's cleanest village.
    Claimed by Discover India magazine as
    the cleanest village in Asia. Enjoy the
    uninterrupted nature; from loud scenic
    waterfalls to the noble trees that house
    birds and small animals.`,
    // hightlights: `<ul>
    // <li>Visit the city tour of Delhi covering Laxmi Narayan Temple, India Gate, Parliament House, Swaminarayan Akshardham temple</li>
    // <li> Attend a presentation, giving a brief overview about the history of Glenburn and the process of growing and manufacturing tea
    // </li>
    // <li>Pay a visit to the Tea Nursery to learn about the different varieties of tea plants</li>
    // <li>Enjoy Tea Tasting Session, at Glenburn Tea Estate</li>
    // <li>Visit the Royal Kingdom of Sikkim and the local Shiv temple</li>
    // <li>Witness a volleyball match that takes place between the local police force and the villagers at 4:30 pm every day, while sipping tea</li>
    // <li>Explore the Tiger Hill, Himalayan Mountaineering Institute Zoo, and Ghoom Monastery in Darjeeling</li>
    // <li>Enjoy the toy train ride for a coveted experience, in Darjeeling</li>
    // </ul>`,
  },
  {
    tour: "Puri",
    price: "16,500",
    review: "20",
    offer: false,
    location: "https://goo.gl/maps/v4WokM7oQJcHnPpx9",
    pdf:
      process.env.PUBLIC_URL + "/travel-pdf/East/Karnataka/Ouri_FVE_O_01.pdf",
    image: [
      process.env.PUBLIC_URL + "/images/East/puri/1.jpeg",
    ],
    description: `One of the most sacred pilgrimage sites
    for Hindus, Puri also known as Jagannath
    Puri, is located in the state of Odisha.
    Famous for the Jagannath temple, Puri is
    believed to be the final resting place of
    Lord Vishnu. Unsurprisingly then, it is a
    very important place of worship for the Hindus. \n
    
    Completing the golden triangle of Odisha
    along with Konark and Bhubaneshwar,
    Puri is a large depository of art and
    architecture of India with the highlight of
    the town being the Shree Jagannath`,
    miniDescription: `North-East India, holds its unique charm and exudes breathtaking beauty. However, the splendor of Shillong attracts a wide range of tourists to the place.`,
    hightlights: `<ul>
    <li>Memorable sunrise views from the Tiger Hill, Darjeeling</li>
    <li>Sightseeing in Darjeeling including Ghoom Monastery and Peace Pagoda</li>
    <li>Visit to Kalimpong attractions including Durpin Monastery and Mangal Dham</li>
    <li>Pelling city tour including Rimbi Rock Garden and Khecheopalri Lake</li>
    <li>Explore Pemayangtse Monastery- one of Sikkim's oldest monasteries</li>
    <li>Enchey Monastery and Flower Exhibition in Gangtok</li>
    <li>Visit to Lachung Monastery in Lachung</li>
    <li>A half-day excursion to the beautiful Yumthang valley</li>
    <li>Excursion to Tsomgo Lake and Baba Mandir</li>
    </ul>`,
  },
  {
    tour: "Guwahati-Shillong",
    price: "12,000",
    review: "16",
    offer: true,
    location: "https://goo.gl/maps/iq6rVLcy1knJ3iAu8",
    image: [
      process.env.PUBLIC_URL + "/images/East/shillong/6.jpg",
      process.env.PUBLIC_URL + "/images/East/shillong/5.jpg",
      process.env.PUBLIC_URL + "/images/East/shillong/1.jpg",
      process.env.PUBLIC_URL + "/images/East/shillong/4.jpg",
      process.env.PUBLIC_URL + "/images/East/shillong/2.jpg",
    ],
    description: `North-East India, holds its unique charm and exudes breathtaking beauty. However, the splendor of Shillong attracts a wide range of tourists to the place and makes it a great tourist destination to visit. Beautiful Guwahati Shillong Cherrapunji Tour Package by Indian Holiday offers you a chance to explore some gems of the Northeast region. The meticulously-designed itinerary is for 4 nights & 5 days.
    Get a chance to visit Shillong, the capital of the state of Meghalaya, popularly called the “Scotland of the East”. Next is, one of the wettest places in the world, Cherrapunjee. Enjoy the thrill of exploring the ‘living roots bridge’ at Mawlynnong, the cleanest village in Asia. Another gem that you explore is Guwahati, the largest city of Assam state. Savor the scenery, enjoy the weather, and explore the wonders.`,
    miniDescription: `North-East India, holds its unique charm and exudes breathtaking beauty. However, the splendor of Shillong attracts a wide range of tourists to the place.`,
    hightlights: `<ul>
    <li>In Shillong tour, visit the Elephanta Falls and the Shillong Peak</li>
    <li> Visit the Seven Sisters Falls in Cherapunjee</li>
    <li>Visit the famous Kamakhya Temple in Guwahati</li>
    <li>Visit the Borapani Lake in Shillong tour</li>
    <li>Visit the Mawsmai Cave and the Thangkharang Park Cherapunji</li>
    <li>Visit Lady Hydari Park</li>
    <li>Visit the cleanest village in Asia, Mawlynnong</li>
    <li>Step foot on the living roots bridge</li>
    </ul>`,
  },
  {
    tour: "Darjeeling",
    price: "13,500",
    review: "16",
    offer: false,
    location: "https://goo.gl/maps/rMdCKKcTQnZEdQAH8",
    image: [
      process.env.PUBLIC_URL + "/images/East/darjeeling/1.jpg",
      process.env.PUBLIC_URL + "/images/East/darjeeling/2.jpg",
      process.env.PUBLIC_URL + "/images/East/darjeeling/3.jpeg",
      process.env.PUBLIC_URL + "/images/East/darjeeling/4.jpeg",
    ],
    description: `The Glenburn Tea Estate Tour takes you on a visit to a beautiful tea estate that lies in the northeast region and is located close to the picturesque hill station of Darjeeling. At the start of the journey enjoy the Sightseeing tour of Delhi covering the major hotspots like the Jama Masjid, Red Fort, Gandhi Memorial, India Gate, Parliament House. On reaching Glenburn Tea Estate, attend a presentation, giving a brief overview of the history of Glenburn and the process of growing and manufacturing tea.`,
    miniDescription: `The Glenburn Tea Estate Tour takes you a beautiful tea estate that lies in the northeast region and is located close to the picturesque hill station of Darjeeling.`,
    hightlights: `<ul>
    <li>Visit the city tour of Delhi covering Laxmi Narayan Temple, India Gate, Parliament House, Swaminarayan Akshardham temple</li>
    <li> Attend a presentation, giving a brief overview about the history of Glenburn and the process of growing and manufacturing tea
    </li>
    <li>Pay a visit to the Tea Nursery to learn about the different varieties of tea plants</li>
    <li>Enjoy Tea Tasting Session, at Glenburn Tea Estate</li>
    <li>Visit the Royal Kingdom of Sikkim and the local Shiv temple</li>
    <li>Witness a volleyball match that takes place between the local police force and the villagers at 4:30 pm every day, while sipping tea</li>
    <li>Explore the Tiger Hill, Himalayan Mountaineering Institute Zoo, and Ghoom Monastery in Darjeeling</li>
    <li>Enjoy the toy train ride for a coveted experience, in Darjeeling</li>
    </ul>`,
  },
  {
    tour: "Magnificent Hills of North East",
    price: "16,500",
    review: "20",
    offer: false,
    location: "https://goo.gl/maps/XTejFNm2YCqDg1BLA",
    image: [
      process.env.PUBLIC_URL + "/images/East/hill/2.jpg",
      process.env.PUBLIC_URL + "/images/East/hill/1.jpg",
      process.env.PUBLIC_URL + "/images/East/hill/3.jpg",
    ],
    description: `The north-eastern part of India is known to be blessed with lush surroundings, salubrious weather, and several other splendors. With an Extended Darjeeling Lachung Gangtok Tour of 10 days and 11 nights, you get a chance to visit these three pristine destinations along with other beautiful places like Pelling, Kalimpong, and Yumthang Valley. This well-planned itinerary includes snow-clad peaks, glistening lakes, cascading waterfalls, ancient monasteries, and much more. Sunrise from Tiger Hill, a visit the Tsomgo Lake, and Pemayangtse Monastery are some of the highlights of this tour. Soak in the divinity and lovely scenery sprinkled all around.`,
    miniDescription: `North-East India, holds its unique charm and exudes breathtaking beauty. However, the splendor of Shillong attracts a wide range of tourists to the place.`,
    hightlights: `<ul>
    <li>Memorable sunrise views from the Tiger Hill, Darjeeling</li>
    <li>Sightseeing in Darjeeling including Ghoom Monastery and Peace Pagoda</li>
    <li>Visit to Kalimpong attractions including Durpin Monastery and Mangal Dham</li>
    <li>Pelling city tour including Rimbi Rock Garden and Khecheopalri Lake</li>
    <li>Explore Pemayangtse Monastery- one of Sikkim's oldest monasteries</li>
    <li>Enchey Monastery and Flower Exhibition in Gangtok</li>
    <li>Visit to Lachung Monastery in Lachung</li>
    <li>A half-day excursion to the beautiful Yumthang valley</li>
    <li>Excursion to Tsomgo Lake and Baba Mandir</li>
    </ul>`,
  },
];

export const WestPackages = [
  {
    tour: "Goa",
    price: "12,500",
    review: "32",
    offer: true,
    location: "https://goo.gl/maps/E3Hqq5g5rGiucHY67",
    pdf: process.env.PUBLIC_URL + "/travel-pdf/West/Goa/GOA_FVW_G_01.pdf",
    image: [
      process.env.PUBLIC_URL + "/images/West/goa/1.jpg",
      process.env.PUBLIC_URL + "/images/West/goa/4.jpg",
      process.env.PUBLIC_URL + "/images/West/goa/2.jpg",
      process.env.PUBLIC_URL + "/images/West/goa/3.jpg",
      process.env.PUBLIC_URL + "/images/West/goa/5.jpg",
    ],
    description: `One of the most visited destinations in India, Goa promises a fun-filled and entertaining holiday to every traveler. A paradise for nature lovers, photographers and adventure enthusiasts, the state allures tourists from all across the globe. Bustling markets, ancient churches, happening parties, beautiful beaches, lip-smacking food, water sports, a trip to Goa is a mish-mash of all these attractions. Delightful Goa is a 3 nights/ 4 days tour which takes you to the party capital of India and makes you fall in love. Embark on this sojourn and come back with memories of a lifetime.`,
    miniDescription: `One of the most visited destinations in India, Goa promises a fun-filled and entertaining holiday to every traveler.`,
    hightlights: `<ul>
        <li>Stroll at Calangute Beach – North Goa</li>
        <li> Shopping at Tibetan market</li>
        <li>Visit Basilica Bom Jesus, St Cajetan, St Francis of Assisi, Se Cathedral, and Church of St. Monica- Old Goa</li>
        <li>Enjoy an ancient ride at the Museum of Christian Art and Archeological Museum</li>
        <li>Visit to the aristocratic mansion - Solar Souto Maior</li>
        <li>Explore Goan rural life at Ancestral Goa</li>
        <li>Pay homage at Church of the Holy Spirit</li>
        <li> Enjoy water sports at Baga Beach</li>
        <li>Seek blessings at Mangeshi Temple, Santa Durga Temple- South Go</li>
        <li>Visit to the grand Menezes Braganza house</li>
        <li>Shopping at the bustling markets of Panjim</li>
        </ul>`,
  },
  {
    tour: "Gujarat Tour",
    price: "12,500",
    review: "16",
    offer: false,
    location: "https://goo.gl/maps/sMTvvpu6QEMsEiHu6",
    pdf:
      process.env.PUBLIC_URL + "/travel-pdf/West/Gujrat/Gujrat_FVW_GJ_01.pdf",
    image: [
      process.env.PUBLIC_URL + "/images/West/gujarat/1.jpg",
      process.env.PUBLIC_URL + "/images/West/gujarat/3.jpg",
      process.env.PUBLIC_URL + "/images/West/gujarat/4.jpg",
      process.env.PUBLIC_URL + "/images/West/gujarat/5.jpg",
      process.env.PUBLIC_URL + "/images/West/gujarat/6.jpg",
    ],
    description: `Gujarat Desert and Lion Safari Tour, a holiday package of 8 nights and 9 days, offers you a chance to spot the big cats and Asiatic Wild Ass, respectively, during your visits to the Gir National Park and the Rann of Kutch. These are two extremely well-known wildlife reserves in the western part of the country. During the itinerary, you also indulge in sightseeing in Gondal, an erstwhile princely state. Below is the day-wise itinerary.`,
    miniDescription: `Gujarat Desert and Lion Safari Tour, a holiday package of 8 nights and 9 days, offers you a chance to spot the big cats and Asiatic Wild Ass.`,
    hightlights: `<ul>
    <li>Morning and evening jeep safari in the Gir National Park</li>
    <li>Sightseeing in Gondal including the Naulakha Palace Museum</li>
    <li>Visit Maharaja’s private grasslands and bird-rich lakes of Gondal</li>
    <li>Wildlife viewing at the Rann of Kutch</li>
    </ul>`,
  },
  {
    tour: "Kutch",
    price: "12,500",
    review: "32",
    offer: true,
    location: "https://goo.gl/maps/98VYeQza71uTkkEc9",
    pdf: process.env.PUBLIC_URL + "/travel-pdf/West/Gujrat/Kutch_FVW_GJ_03.pdf",
    image: [
      process.env.PUBLIC_URL + "/images/West/kutch/1.jpg",
      process.env.PUBLIC_URL + "/images/West/kutch/2.jpg",
      process.env.PUBLIC_URL + "/images/West/kutch/3.jpg",
    ],
    description: `Kutch district is the world’s best salt desert
    which has the views and terrain to daze
    anyone. The monsoon season is exceptionally
    beautiful which covers the desert with water
    and when the winter comes, the salt becomes
    dominant and looks so fresh. This becomes
    more enchanting when the Rann Utsav takes
    place. Rann Utsav normally takes place in
    winters so at that time the desert shows off
    its full glory and beauty. Kutch festival
    organizes enormous wonderful shows and
    activities every year including folk dances
    like Garba, Hallisaka and Tippani, Gujarati
    Thali, folk dramas, and many more.`,
    miniDescription: `Kutch district is the world’s best salt desert
    which has the views and terrain to daze
    anyone. The monsoon season is exceptionally
    beautiful.`,
    hightlights: `<ul>
        <li>After arrival, we will proceed to Kutch
        district. Then we will visit Kutch (Rann
        Utsav) and enjoy the time there and in
        the evening we will get to check into
        the hotel. After that, we will have our
        lunch in the dining area. Then we will
        go for an evening Hi-Tea at White
        Rann Diner following that, we will go
        shopping or adventure activities
        around.
        </li>
        <li> Another day with the wonderful activities
        and delicious dinners
        In the morning we will go to White Rann
        Diner for breakfast in the dining area. Then
        we will let you have the pace of your own
        and you can go around and wander for
        activities and shopping.
        </li>
        </ul>`,
  },
  {
    tour: "Patan",
    price: "12,500",
    review: "16",
    offer: false,
    location: "https://goo.gl/maps/qwzz2ggGvkcDGokcA",
    pdf: process.env.PUBLIC_URL + "/travel-pdf/West/Gujrat/Patan_FVW_GJ_01.pdf",
    image: [
      process.env.PUBLIC_URL + "/images/West/patan/1.jpeg",
      process.env.PUBLIC_URL + "/images/West/patan/2.jpeg",
      process.env.PUBLIC_URL + "/images/West/patan/3.jpeg",
    ],
    description: `Capital of Gujarat's Chavda and
    Chaulukya dynasties, Patan features
    architectural wonders. The city has a
    history of thriving trade that has now
    evolved into recognition of the city as
    the northern capital of Gujarat. Treat
    your eyes with the landscapes and
    your tastebuds with never ending Gujarati delicacies.`,
    miniDescription: `Capital of Gujarat's Chavda and
    Chaulukya dynasties, Patan features
    architectural wonders. The city has a
    history of thriving trade.`,
    // hightlights: `<ul>
    // <li>Morning and evening jeep safari in the Gir National Park</li>
    // <li>Sightseeing in Gondal including the Naulakha Palace Museum</li>
    // <li>Visit Maharaja’s private grasslands and bird-rich lakes of Gondal</li>
    // <li>Wildlife viewing at the Rann of Kutch</li>
    // </ul>`,
  },
  {
    tour: "Ujjain Mahakal",
    price: "12,500",
    review: "32",
    offer: true,
    location: "https://goo.gl/maps/hWAm7Ny7KHnrtYYG9",
    pdf:
      process.env.PUBLIC_URL +
      "/travel-pdf/West/MadhyaPradesh/Ujjain-Mahakal_FVW_MP_01.pdf",
    image: [
      process.env.PUBLIC_URL + "/images/West/ujjain/1.jpeg",
      process.env.PUBLIC_URL + "/images/West/ujjain/2.jpg",
      process.env.PUBLIC_URL + "/images/West/ujjain/3.webp"
    ],
    description: `The City of Mahakal Introduction –
    Located on the eastern bank of river
    Kshipra, Ujjain is one of the most
    sacred city of India, one amongst the
    seven sacred cities, sapta-puris, as
    per ancient literatures. It was known
    as Ujjaini, Avantika, Amravati,
    Pratikalpa and Kumudduity in old times.`,
    miniDescription: `The City of Mahakal Introduction –
    Located on the eastern bank of river
    Kshipra, Ujjain is one of the most
    sacred city of India, one amongst the
    seven sacred cities.`,
    // hightlights: `<ul>
    //     <li>Stroll at Calangute Beach – North Goa</li>
    //     <li> Shopping at Tibetan market</li>
    //     <li>Visit Basilica Bom Jesus, St Cajetan, St Francis of Assisi, Se Cathedral, and Church of St. Monica- Old Goa</li>
    //     <li>Enjoy an ancient ride at the Museum of Christian Art and Archeological Museum</li>
    //     <li>Visit to the aristocratic mansion - Solar Souto Maior</li>
    //     <li>Explore Goan rural life at Ancestral Goa</li>
    //     <li>Pay homage at Church of the Holy Spirit</li>
    //     <li> Enjoy water sports at Baga Beach</li>
    //     <li>Seek blessings at Mangeshi Temple, Santa Durga Temple- South Go</li>
    //     <li>Visit to the grand Menezes Braganza house</li>
    //     <li>Shopping at the bustling markets of Panjim</li>
    //     </ul>`,
  },
  {
    tour: "Jyotilinga",
    price: "12,500",
    review: "16",
    offer: false,
    location: "",
    pdf:
      process.env.PUBLIC_URL +
      "/travel-pdf/West/Maharashtra/Jyotilinga_FVW_MH_01.pdf",
    image: [
      process.env.PUBLIC_URL + "/images/West/gujarat/1.jpg",
      process.env.PUBLIC_URL + "/images/West/gujarat/3.jpg",
      process.env.PUBLIC_URL + "/images/West/gujarat/4.jpg",
      process.env.PUBLIC_URL + "/images/West/gujarat/5.jpg",
      process.env.PUBLIC_URL + "/images/West/gujarat/6.jpg",
    ],
    description: `The beauty of scenically blessed state
    Maharashtra is enhanced by the religious
    touch of sacred temples dedicated to Lord
    Shiva, famously called as Jyotirlingas. Out of
    total all twelve jyotirlingas unfurled within
    the boundaries of the whole country, five
    resides in Maharashtra,The five Jyotirlingas
    of Maharashtra i.e Bhimashankar,
    Trimbakeshwar, Grishneshwar, Aundha Nagnath and Vaijanath,`,
    miniDescription: `The beauty of scenically blessed state
    Maharashtra is enhanced by the religious
    touch of sacred temples dedicated to Lord
    Shiva, famously called as Jyotirlingas.`,
    // hightlights: `<ul>
    // <li>Morning and evening jeep safari in the Gir National Park</li>
    // <li>Sightseeing in Gondal including the Naulakha Palace Museum</li>
    // <li>Visit Maharaja’s private grasslands and bird-rich lakes of Gondal</li>
    // <li>Wildlife viewing at the Rann of Kutch</li>
    // </ul>`,
  },
  {
    tour: "Jawai Rajashan",
    price: "12,500",
    review: "32",
    offer: true,
    location: "https://goo.gl/maps/d1EUrw5U4BVXAeh7A",
    pdf:
      process.env.PUBLIC_URL + "/travel-pdf/West/Rajasthan/Jawai_FVW_R_01.pdf",
    image: [
      process.env.PUBLIC_URL + "/images/West/goa/1.jpg",
      process.env.PUBLIC_URL + "/images/West/goa/4.jpg",
      process.env.PUBLIC_URL + "/images/West/goa/2.jpg",
      process.env.PUBLIC_URL + "/images/West/goa/3.jpg",
      process.env.PUBLIC_URL + "/images/West/goa/5.jpg",
    ],
    description: `Jawai Bandh A gem in rajasthan's crown Hidden in plain sight, the village is
    best known for its landscapes, wildlife
    and an offbeat getaway for tourists.
    This location is one of the many gems
    in Rajasthan's crown and will surely
    take your breath away. The history of
    Jawai Bandh dates back to 1946;
    attracting attention from the people
    due to the construction of the dam.`,
    miniDescription: `Jawai Bandh A gem in rajasthan's crown Hidden in plain sight, the village is
    best known for its landscapes, wildlife
    and an offbeat getaway for tourists.`,
    // hightlights: `<ul>
    //     <li>Stroll at Calangute Beach – North Goa</li>
    //     <li> Shopping at Tibetan market</li>
    //     <li>Visit Basilica Bom Jesus, St Cajetan, St Francis of Assisi, Se Cathedral, and Church of St. Monica- Old Goa</li>
    //     <li>Enjoy an ancient ride at the Museum of Christian Art and Archeological Museum</li>
    //     <li>Visit to the aristocratic mansion - Solar Souto Maior</li>
    //     <li>Explore Goan rural life at Ancestral Goa</li>
    //     <li>Pay homage at Church of the Holy Spirit</li>
    //     <li> Enjoy water sports at Baga Beach</li>
    //     <li>Seek blessings at Mangeshi Temple, Santa Durga Temple- South Go</li>
    //     <li>Visit to the grand Menezes Braganza house</li>
    //     <li>Shopping at the bustling markets of Panjim</li>
    //     </ul>`,
  },
  {
    tour: "Mount Abu-Udaipur",
    price: "12,500",
    review: "16",
    offer: false,
    pdf:
      process.env.PUBLIC_URL +
      "/travel-pdf/West/Rajasthan/Mount-Abu-Udaipur_FVW_R_02.pdf",
    location: "https://goo.gl/maps/49cp6i8uBwbjSw627",
    image: [
      process.env.PUBLIC_URL + "/images/West/mountAbu/1.jpg",
      process.env.PUBLIC_URL + "/images/West/mountAbu/2.jpg",
      process.env.PUBLIC_URL + "/images/West/mountAbu/3.jpg",
    ],
    description: `A gem in rajasthan's crown
    Udaipur is the capital of the erstwhile
    kingdom of Mewar. The kingdom of
    Mewar, with which many legends of
    bravery are associated, was
    considered the most respectable of all
    Rajput princely states in Rajasthan.
    The Rulers of Mewar are still
    remembered for their bravery &
    courage they showed for protecting
    their motherland from external
    invaders.`,
    miniDescription: `A gem in rajasthan's crown
    Udaipur is the capital of the erstwhile
    kingdom of Mewar. The kingdom of
    Mewar, with which many legends of
    bravery are associated.`,
    hightlights: `<ul>
    <li>Mount Abu
    Check-in to the hotel. Rest of
    the day free for leisure
    activities. Overnight stay will
    be at the hotel in Mount Abu.
    </li>
    <li>Mount Abu
    After breakfast, start with a local city tour.
    You will be visiting world famous Dilwara
    Jain Temple, Nakki Lake and Brahmin
    Kumari Ashram. Dilwara Temples are a
    splendid group of Jain temples. The
    temples present a live testimony of carving
    marble in supreme heights.
    </li>
    <li>Udaipur
    After breakfast, proceed for a journey to Udaipur.
    Arrival and check in at the hotel, evening free at
    leisure.
    
    Overnight stay will be at the hotel in Udaipur.
    </li>
    <li>Udaipur
    After breakfast , you will visiting local
    sightseeing attractions of Udaipur. The
    lake city of Udaipur was built in 1559
    A.D. by Maharaja Udai Singh. Udaipur is
    one of the most popular tourist
    destination among holiday couples in
    India.
    </li>
    <li>Udaipur
    After breakfast, you will
    visiting local sightseeing
    attractions of Udaipur / enjoy
    a boat ride at the lake pichola
    . Afternoon free at leisure /
    shopping
    
    Overnight stay will be at
    hotel in Udaipur.
    </li>
    <li>Departure
    After breakfast departure for airport
    </li>
    </ul>`,
  },
  {
    tour: "Rajasthan",
    price: "11,000",
    review: "11",
    offer: true,
    location: "https://goo.gl/maps/73G272JhqV8mEHrL6",
    pdf:
      process.env.PUBLIC_URL +
      "/travel-pdf/West/Rajasthan/Rajasthan_FVW_R_03.pdf",
    image: [
      process.env.PUBLIC_URL + "/images/North/rajasthan/1.jpg",
      process.env.PUBLIC_URL + "/images/North/rajasthan/3.jpg",
      process.env.PUBLIC_URL + "/images/North/rajasthan/4.jpeg",
      process.env.PUBLIC_URL + "/images/North/rajasthan/2.jpg",
    ],
    description: `Rajasthan ‘Land of Kings’ or ‘Land of Kingdom’ is
    India’s largest state by area. The state located on
    northwest part of country and is a home of cultural
    diversity. Its features include the ruins of Indus Valley
    Civilization, Temples, Forts and Fortresses in almost
    every city. Rajasthan divided into 9 regions; Ajmer
    State, Hadoti, Dhundhar, Gorwar, Shekhawati, Mewar,
    Marwar, Vagad and Mewat which are equally rich in
    its heritage and artistic contribution. These regions
    have a parallel history which goes along with that of
    the state. \n
    A world heritage site, Keoladeo National Park near
    Bharatpur, known for its bird life. Apart from this
    state has two national tiger reserves namely
    Ranthambore National Park at Sawai Madhopur and
    Sariska Tiger Reserve in Alwar.`,
    miniDescription: `Rajasthan ‘Land of Kings’ or ‘Land of Kingdom’ is
    India’s largest state by area. The state located on
    northwest part of country and is a home of cultural
    diversity.`,
    hightlights: `<ul>
    <li>Jodhpur sightseeing including Mehrangarh Fort</li>
    <li> City tour of Jaisalmer</li>
    <li>Camel Safari at the Thar Desert</li>
    <li>Tour of the royal Laxmi Niwas Palace</li>
    <li>Visit the National Research Center on Camel</li>
    <li>Jaipur City Tour along with Amer Fort</li>
    </ul>`,
  },
];
